import React from 'react'
import styled, { keyframes } from 'styled-components'

const Loader = ({ style, color }) => (
  <div style={{...style}}>
    <Dot1 color={color} />
    <Dot2 color={color} />
    <Dot color={color} />
  </div>
)

const bounceDelay = keyframes`
  0%, 80%, 100% {
    -webkit-transform: scale(0);
    transform: scale(0);
  } 40% {
    -webkit-transform: scale(1.0);
    transform: scale(1.0);
  }
`

const Dot = styled.div`
  width: 10px;
  height: 10px;
  margin-right: 5px;
  background-color: ${props => props.color || props.theme.primaryColor};
  border-radius: 100%;
  display: inline-block;
  -webkit-animation: ${bounceDelay} 1.4s infinite ease-in-out both;
  animation: ${bounceDelay} 1.4s infinite ease-in-out both;
`

const Dot1 = styled(Dot)`
  -webkit-animation-delay: -0.32s;
  animation-delay: -0.32s;
`

const Dot2 = styled(Dot)`
  -webkit-animation-delay: -0.16s;
  animation-delay: -0.16s;
`

export default Loader



// WEBPACK FOOTER //
// ./src/ChatWidget/components/common/Loader.js